import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  distributionService,
  GenerateResult,
  StorePendingSummary,
} from "../services/distributionService";

/**
 * B2.23 — hooks para la pantalla DistribucionTiendaPage.
 *
 * `useDistributionPending` refresca cada 2 min la lista ordenada por
 * criticality_score; `useGenerateDistribution` hace el POST de un
 * click y invalida la query tras éxito para reflejar el nuevo state.
 */
export function useDistributionPending(): {
  data: StorePendingSummary[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ["distribution", "pending-by-store"],
    queryFn: () => distributionService.getPendingByStore(),
    refetchInterval: 2 * 60 * 1000,
    staleTime: 30 * 1000,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
}

export function useGenerateDistribution(): {
  mutateAsync: (input: {
    store?: string;
    request_id?: string;
  }) => Promise<GenerateResult>;
  isPending: boolean;
} {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: { store?: string; request_id?: string }) =>
      distributionService.generateDistribution(input),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ["distribution", "pending-by-store"],
      });
    },
  });
  return {
    mutateAsync: (input) => mutation.mutateAsync(input),
    isPending: mutation.isPending,
  };
}
